import { useEffect, useRef } from "react"
import { useLocation } from "react-router-dom"

import { track } from "./mixpanel"
import { getPageInfo } from "./utils/page-name"

// Emits one "Page viewed" event per navigation. This replaces the per-page
// track() calls, which fired only on first mount and used a different event name
// per page, making "Pages visited" impossible to report on as a single series.
//
// Deliberately does not send location.search: query strings here carry access
// tokens (?token=) and would leak them into Mixpanel.
const PageViewTracker = () => {
  const { pathname } = useLocation()
  const previousPathRef = useRef(null)

  useEffect(() => {
    const { page, route } = getPageInfo(pathname)

    track("Page viewed", {
      page,
      route,
      path: pathname,
      from_path: previousPathRef.current,
    })

    previousPathRef.current = pathname
  }, [pathname])

  return null
}

export default PageViewTracker
